var chunkMapping = {
	"10": [
		5010
	],
	"273": [
		83273
	],
	"275": [
		85275
	],
	"320": [
		67320
	],
	"391": [
		60391
	],
	"428": [
		99428
	],
	"435": [
		20435
	],
	"453": [
		94453
	],
	"585": [
		78585
	],
	"998": [
		25998
	]
};
var idToExternalAndNameMapping = {
	"5010": [
		"default",
		"./versionMatrix",
		36135
	],
	"20435": [
		"default",
		"./SafetyHealthFleetWideView",
		36135
	],
	"25998": [
		"default",
		"./SafetyHealthVehicleView",
		36135
	],
	"60391": [
		"default",
		"./SafetyDetailsDCVC",
		36135
	],
	"67320": [
		"default",
		"./SafetyEventsFleetWideView",
		36135
	],
	"78585": [
		"default",
		"./VideoLibraryFleetWideView",
		36135
	],
	"83273": [
		"default",
		"./Notifications",
		36135
	],
	"85275": [
		"default",
		"./SafetyEventDetails",
		36135
	],
	"94453": [
		"default",
		"./FuelPerformanceAnalysis",
		36135
	],
	"99428": [
		"default",
		"./SafetyEventsVehicleFleetWideView",
		36135
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}